var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcelFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_47_9325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5008 47.7254H5.94336V0.274597H31.2226V10.9208H41.5008V47.7254Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56836 -0.100403H31.5976V10.5458H41.8758V48.1004H5.56836V-0.100403ZM6.31836 0.649597V47.3504H41.1258V11.2958H30.8476V0.649597H6.31836Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0862 12.19H2.05772C0.921272 12.19 0 13.1121 0 14.2495V34.2953C0 35.4327 0.921272 36.3548 2.05772 36.3548H22.0862C23.2226 36.3548 24.1439 35.4327 24.1439 34.2953V14.2495C24.1439 13.1121 23.2226 12.19 22.0862 12.19Z",
    fill: "#107C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2001 33.3H15.7342L5.4751 16.05H9.01032L19.2001 33.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4751 33.3H8.94101L19.2001 16.05H15.6649L5.4751 33.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2225 18.3685H25.406V20.9497H31.2225V18.3685Z",
    fill: "#21A365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4107 18.3685H32.5942V20.9497H38.4107V18.3685Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2225 22.2678H25.406V24.8491H31.2225V22.2678Z",
    fill: "#107C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4107 22.2678H32.5942V24.8491H38.4107V22.2678Z",
    fill: "#21A365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2225 26.1671H25.406V28.7484H31.2225V26.1671Z",
    fill: "#195D38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4107 26.1671H32.5942V28.7484H38.4107V26.1671Z",
    fill: "#104B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2956 10.9543H31.3615C31.2847 10.9543 31.2227 10.8923 31.2227 10.8154V0.467355C31.2227 0.297103 31.4301 0.213625 31.5475 0.336645L41.4295 10.6391C41.5431 10.7577 41.4591 10.9549 41.2951 10.9549L41.2956 10.9543Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5977 0.930682V10.5793H40.8526L31.5977 0.930682ZM41.8238 10.9566L42.2014 10.5793H41.8252C41.7997 10.5086 41.7587 10.4407 41.7004 10.3797L41.7001 10.3795L31.8188 0.0777365C31.8186 0.0776031 31.8185 0.0774697 31.8184 0.0773364C31.4659 -0.291293 30.8477 -0.0389728 30.8477 0.467373V10.8154C30.8477 11.0991 31.0773 11.3293 31.3615 11.3293H40.3899L40.3893 11.3299H41.2951C41.5563 11.3299 41.7495 11.1648 41.8238 10.9566Z",
    fill: "#818181"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_9325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelFile);
export default __webpack_public_path__ + "static/media/excel-file.538680f0f44d49bedaa7f034d22077de.svg";
export { ForwardRef as ReactComponent };